enum ForecasterDateTab {
  Week,
  Day,
  Month,
  Custom,
}

export default ForecasterDateTab;
